import { Modal, Typography } from "antd";
import React from "react";


const BaseModal = (props) => {

  let title = <Typography.Text>{ props.mainTitle }</Typography.Text>
  if (props.subTitle) {
    title = (
      <>
        { title }
        <Typography.Text type="secondary"> | { props.subTitle }</Typography.Text>
      </>
    );
  }
  return <Modal style={ {
    top: 15
  } } title={ title } { ...props }  >
    <div className="basemodel" >
      { props.children }
    </div>
  </Modal>;
};

export default BaseModal;
